import { render, staticRenderFns } from "./StudentSection.vue?vue&type=template&id=b2061398&scoped=true&"
import script from "./StudentSection.vue?vue&type=script&lang=js&"
export * from "./StudentSection.vue?vue&type=script&lang=js&"
import style0 from "./StudentSection.vue?vue&type=style&index=0&id=b2061398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2061398",
  null
  
)

export default component.exports